import * as actions from 'actions/importJobs';
import * as importMessagesActions from 'actions/importMessages';

export const defaultState = {
  loading: true,
  error: false,
  messagesDownloadInProgress: false,
  data: {},
  errorCount: 0,
  warningCount: 0,
};

export default function importJobDetailsReport(state = defaultState, action) {
  switch (action.type) {
    case actions.LOAD_IMPORT: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case actions.LOAD_IMPORT_SUCCESS: {
      const { errors, warnings } = action.payload;

      return {
        ...state,
        loading: false,
        error: false,
        data: {
          ...action.payload,
        },
        errorCount: (errors && errors.total) || 0,
        warningCount: (warnings && warnings.total) || 0,
      };
    }
    case actions.LOAD_IMPORT_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case importMessagesActions.DOWNLOAD_CSV_START: {
      return {
        ...state,
        messagesDownloadInProgress: true,
      };
    }
    case importMessagesActions.DOWNLOAD_CSV_SUCCESS: {
      return {
        ...state,
        messagesDownloadInProgress: false,
      };
    }
    case importMessagesActions.DOWNLOAD_CSV_FAIL: {
      return {
        ...state,
        messagesDownloadInProgress: false,
      };
    }
    default:
      return state;
  }
}
